import React from 'react'
import Layout from '../components/Layout'
import Banner from '../components/Banner'
import SEO from '../components/Seo'
import { InlineForm, InlineTextarea } from 'react-tinacms-inline'
import { InlineWysiwyg } from 'react-tinacms-editor'
import { useJsonForm, DeleteAction } from 'gatsby-tinacms-json'
import { usePlugin } from 'tinacms'

export default function Faqs({ pageContext }) {

    const formConfig = {
        id: 1213,
        actions: [DeleteAction],
        label: 'Edit FAQ',
        fields: [
            {
                label: 'SEO Title',
                name: 'rawJson.seo_title',
                component: 'textarea'
            },
            {
                label: 'Meta Description',
                name: 'rawJson.meta_description',
                component: 'textarea'
            }
        ]
    }
    const [modifiedData, form] = useJsonForm(pageContext, formConfig)
    usePlugin(form)

    return (
        <>
            <SEO
                title={modifiedData.seoTitle}
                description={modifiedData.metaDescription}
            />
            <Layout>
                <div className="mainContainer">
                    <div className="container-fluid s2">
                        <div className="container">
                            <InlineForm form={form} >
                                <div className="row">
                                    <h1 className="center">
                                        <InlineTextarea name="rawJson.title" />
                                    </h1>
                                    <div className="container center">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <InlineWysiwyg name="rawJson.contentLeft" format="html">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: modifiedData.contentLeft,
                                                }}
                                            />
                                        </InlineWysiwyg>
                                    </div>
                                    <div className="col-md-6">
                                        <InlineWysiwyg name="rawJson.contentRight" format="html">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: modifiedData.contentRight,
                                                }}
                                            />
                                        </InlineWysiwyg>
                                    </div>
                                </div>
                            </InlineForm>
                        </div>
                    </div>
                </div>
                <Banner />
            </Layout>
        </>
    )
}
